import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, Paper, Button, Link } from "@mui/material";
import HeaderLogo from "../common/HeaderLogo";
import { defaults } from "./PasswordConstants";

const ForgotPasswordSuccess = ({ setIsForgotPassword }) => {
  const { linkSent, checkEmail, returnToLogin } = defaults;

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <HeaderLogo />
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
          data-testid="reset-link-success-box"
        >
          <Paper
            sx={{
              backgroundColor: "background.primary",
              border: "1px solid var(--elevation-outlined, #FFFFFF1F)",
              color: "text.primary",
              p: 6,
              width: 450,
            }}
          >
            <Typography variant="h4">{linkSent}</Typography>
            <Typography sx={{ mt: 2, mb: 2, letterSpacing: "0.5px" }}>
              {checkEmail}
            </Typography>
            <Box fullWidth textAlign="center" mt={6}>
              <Button
                variant="text"
                color="primary"
                size="large"
                data-testid="return-login-button"
                onClick={() => setIsForgotPassword(false)}
              >
                {returnToLogin}
              </Button>
            </Box>
          </Paper>
        </Box>
      </Box>
    </>
  );
};

ForgotPasswordSuccess.defaultProps = {
  setIsForgotPassword: () => {},
};

ForgotPasswordSuccess.propTypes = {
  setIsForgotPassword: PropTypes.func,
};

export default ForgotPasswordSuccess;
